import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { rootPath } from "@travily/routes";
import { PageFrame } from "@/layouts/page-frame";
import { InvalidView } from "./invalid.view";

// Shown for a tampered/unknown download token — no buyer details, just a dead end.
const DownloadInvalidPage = () => (
  <PageFrame>
    <Head title={t("web.purchases.downloads.invalid.meta_title")} />

    <InvalidView homeHref={rootPath()} />
  </PageFrame>
);

export default DownloadInvalidPage;
